import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Perdía horas armando informes para las obras sociales. Con estas planillas, completo todo en 5 minutos y me las aprueban sin vueltas. Un antes y un después en mi consultorio.',
  name: 'Valeria R.',
  details: 'Lic. en Kinesiología, Córdoba'
}, {
  quote: 'Recién me recibo y no sabía cómo organizar las historias clínicas. Este pack me dio la estructura profesional que necesitaba desde el día uno. Excelente inversión.',
  name: 'Tomás G.',
  details: 'Kinesiólogo Fisiatra, Rosario'
}, {
  quote: 'El respaldo legal que te da tener todo documentado no tiene precio. Las fichas de evaluación y seguimiento son súper completas y fáciles de adaptar a cada paciente.',
  name: 'Luciana M.',
  details: 'Lic. en Kinesiología, CABA'
}];
export function Testimonials() {
  return <section className="py-10 md:py-20 bg-slate-50" data-id="element-335">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-336">
        <div className="text-center mb-8 md:mb-12" data-id="element-337">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3" data-id="element-338">
            Lo que dicen quienes ya lo tienen
          </h2>
          <div className="w-16 h-1 bg-brand-accent mx-auto rounded-full" data-id="element-339"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5" data-id="element-340">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="bg-white p-5 rounded-xl shadow-sm border border-slate-100 flex flex-col h-full" data-id="element-341">
              <div className="flex text-yellow-400 mb-3" data-id="element-342">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-343" />)}
              </div>
              <p className="text-slate-700 text-sm md:text-[15px] mb-4 flex-grow leading-relaxed" data-id="element-344">
                "{testimonial.quote}"
              </p>
              <div className="pt-3 border-t border-slate-100" data-id="element-345">
                <p className="font-bold text-slate-900 text-sm" data-id="element-346">
                  {testimonial.name}
                </p>
                <p className="text-xs text-slate-500 mt-0.5" data-id="element-347">
                  {testimonial.details}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}